export type OneyIdentifier<T> = {
  identifier: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new (...args: any[]): T;
};

export function OneyIdentifier<T>(identifier: string): OneyIdentifier<T> {
  const ctor = function (this: T) {
    throw new Error(`OneyIdentifier is not a real constructor, don't call it: ${identifier}`);
  };

  // use to have identifier like constructor.name
  Object.defineProperty(ctor, 'name', { value: identifier, writable: false, configurable: true });

  ctor.identifier = identifier;

  return ctor as unknown as OneyIdentifier<T>;
}
